<div class="ng-bento">
	<bento-alert [items]="alerts"></bento-alert>
	<div [bentoBusyLoader]="isLoading"
			*ngIf="isLoading" class="loader">
	</div>

	<div class="security-container" *ngIf="!isLoading">
		<h1 class="no-margin-t" translate="Bluemoon.Shell.Navigation.SettingSecurity"></h1>

		<div class="row content-setup" *ngIf="isFlexiblePassword">
				<h2 class="col-xs-12" translate="Onvio.Setup.Security.PasswordExpiration.Title"></h2>
				<div class="form-group col-lg-8">
					<p translate="Onvio.Setup.Security.PasswordExpiration.Description"></p>
					<div class="row col-lg-4 col-md-5 col-sm-6">
						<label for="pwd-expiration-option"><span translate="Onvio.Setup.Security.PasswordExpiration.Interval"></span></label>
						<select id="pwd-expiration-option" [(ngModel)]="pwdExpirationDays" bentoSelect name="pwd-expiration-option" class="form-control">
							<option [value]="-1" [selected]="value === pwdExpirationDays" [translate]="'Onvio.Setup.Security.PasswordExpiration.NeverPrompted'"></option>
							<option [value]="90" [selected]="value === pwdExpirationDays" [translate]="'Onvio.Setup.Security.PasswordExpiration.Days'" [translateParams]="{interval: 90}"></option>
							<option [value]="180" [selected]="value === pwdExpirationDays" [translate]="'Onvio.Setup.Security.PasswordExpiration.Days'" [translateParams]="{interval: 180}"></option>
							<option [value]="365" [selected]="value === pwdExpirationDays" [translate]="'Onvio.Setup.Security.PasswordExpiration.Days'" [translateParams]="{interval: 365}"></option>
						</select>
					</div>
				</div>
		</div>

		<div class="row content-setup">
			<h2 class="col-xs-12" translate="bm.components.mfa.user.name"></h2>
			<div class="col-lg-8">
				<p translate="onvio.setup.mfa.Description"></p>

				<div class="mfa-toggle-group">
					<div translate="Core.Captions.Client.ClassOther" class="mfa-header"></div>
					<div [(ngModel)]="clientMfaRequired" ngbRadioGroup
								class="btn-group btn-group-toggle" name="clientToggle">
						<label ngbButtonLabel class="btn btn-outline-primary btn-toggle">
							<span translate="onvio.setup.mfa.Required"></span>
							<input ngbButton type="radio" [value]="true">
						</label>
						<label ngbButtonLabel class="btn btn-outline-primary btn-toggle">
							<span translate="onvio.setup.mfa.Optional"></span>
							<input ngbButton type="radio" [value]="false">
						</label>
					</div>
					<span class="mfa-label"
								[translate]="clientMfaRequired ? 'onvio.setup.mfa.ClientRequiredDescription' : 'onvio.setup.mfa.ClientOptionalDescription'"></span>
				</div>

				<div *ngIf="!staffMfaRequiredOverrideIac" class="mfa-toggle-group">
					<div translate="Core.Captions.Employee.ClassOther" class="mfa-header"></div>
					<div [(ngModel)]="staffMfaRequired" ngbRadioGroup
								class="btn-group btn-group-toggle" name="staffToggle">
						<label ngbButtonLabel class="btn btn-outline-primary btn-toggle">
							<span translate="onvio.setup.mfa.Required"></span>
							<input ngbButton type="radio" [value]="true">
						</label>
						<label ngbButtonLabel class="btn btn-outline-primary btn-toggle">
							<span translate="onvio.setup.mfa.Optional"></span>
							<input ngbButton type="radio" [value]="false">
						</label>
					</div>
					<span class="mfa-label"
								[translate]="staffMfaRequired ? 'onvio.setup.mfa.StaffRequiredDescription' : 'onvio.setup.mfa.StaffOptionalDescription'"></span>
				</div>
			</div>
		</div>
	</div>

	<div class="page-footer" *ngIf="!isLoading">
		<button class="btn btn-primary"
			(click)="save()"
			translate="onvio.setup.notifications.save"
			[disabled]="isSaving"
			[bentoBusyLoader]="isSaving">
		</button>
		<button class="btn btn-outline-primary"
			(click)="cancel()"
			translate="Onvio.Setup.Theme.Buttons.DiscardChanges"
			[disabled]="isSaving">
		</button>
	</div>

</div>
